import * as React from "react";

const Diente43 = (props) => {

  //"#fff"
  let color= '#fff';
  //---------------
  //if(props.pza === props.pieza ){    //si es true, lo cambiamos de color el diente
    color= props.color;
  //}
  return (
  <svg style={{ width: "inherit", height: "inherit" }}
          version="1.1"
          viewBox="0 0 19.488189 31.535433"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          {...props}
      >
   
   
   

     <g
      
      transform="translate(0,-1020.8268)"
    >
      <path
        fill= "#000"
          d="m 13.590144,1021.3034 c -1.2895,0.3308 -8.1931195,2.3724 -9.2574795,3.338 -1.01726,0.9229 -3.79941001,3.4468 -3.93808001,6.7209 0.34768,5.1572 2.40193001,9.8123 3.17135001,12.7305 1.28298,2.8184 6.3013604,8.0758 8.1117995,8.0895 1.9522,-0.164 4.29141,-6.5892 4.72243,-8.0896 0.64489,-1.9096 2.63288,-14.655 2.78456,-16.5932 -0.23986,-3.6082 -1.54634,-6.9741 -5.59458,-6.1961 z m 4.48537,6.2105 c 0.17389,2.2294 -2.07594,15.1987 -2.44197,16.4878 -0.59855,1.476 -2.63176,7.0283 -4.08008,7.162 -1.7018491,0.074 -6.5805195,-5.6417 -7.3051695,-7.8072 -0.70851,-1.8555 -2.42989,-8.0964 -2.91853,-12.0634 -0.1314201,-1.9823 2.59977,-5.2868 3.46176,-5.8866 1.20378,-0.8377 8.1719995,-3.073 9.2649895,-3.3717 3.0999,-0.1481 4.15237,3.2842 4.019,5.4791 z m -4.03195,-0.9247 c -0.95823,-1.947 -7.6472495,2.7308 -7.9073095,3.3804 0.36761,1.1977 6.0094695,-3.5329 7.1089895,-2.9442 -0.1189,1.0934 -0.50523,3.0277 -0.68548,3.8397 -0.26113,1.1762 2.08365,-0.6362 2.81079,-0.2271 0.21971,1.6722 -3.12438,12.2279 -2.42011,12.63 1.24559,-0.3467 3.39211,-11.5698 3.2021,-13.4061 -1.01096,-0.834 -2.2354,0.6031 -2.5939,0.3541 0.13711,-1.4557 0.68502,-3.0059 0.68502,-3.0059 0,0 0.16046,-0.3534 -0.2001,-0.6209 z"
      />
      <path
      fill={color}
      stroke="#000"
      strokeWidth={0.012}
      d="m 14.412859,1021.9734 c -3.266886,0.7713 -6.5972041,1.7215 -9.5436799,3.3408 -2.2196022,1.8425 -4.31848451,4.8032 -3.3003121,7.8052 1.1992014,5.0287 1.8719727,10.624 5.6233871,14.5363 1.2841043,1.2326 2.4894408,3.1162 4.3506379,3.4379 2.266491,-1.3696 2.962613,-4.3017 3.806258,-6.648 1.551075,-5.982 2.728724,-12.1729 2.604077,-18.371 -0.03662,-1.9265 -1.348107,-4.2216 -3.540368,-4.1012 z m -1.387413,3.898 c 1.332498,-0.1448 1.580368,1.4737 0.982915,2.3627 -0.201278,0.5005 -0.546536,2.0223 0.502161,1.4841 0.764187,-0.5916 2.059403,-0.3603 1.774911,0.8043 -0.511829,4.1064 -1.182402,8.3222 -2.779876,12.1532 -0.466476,0.9982 -0.84968,-0.1406 -0.536188,-0.6458 0.597474,-3.7942 2.053999,-7.5046 2.359615,-11.3149 -0.801216,-0.4735 -2.025702,0.735 -2.744588,0.369 -0.105854,-1.3993 0.963022,-3.0387 0.376151,-4.312 -2.287899,0.7932 -4.2681668,2.7463 -6.6346394,3.1338 1.5583696,-2.029 4.1506424,-3.3131 6.6006234,-4.0294 l 0.09768,0 0.001,0 z"
    />
    </g>



    
    
  
  </svg>
)}
export default Diente43;